import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngxs/store";

@Component({
	selector: "app-reset",
	template: ``, // Empty template - no visible UI
	standalone: true,
})
export class ResetComponent implements OnInit {
	constructor(
		private router: Router,
		private store: Store,
	) {}

	ngOnInit(): void {
		console.log("Reset component initialized");

		try {
			localStorage.clear();
			console.log("localStorage cleared");
			this.store.reset({});

			setTimeout(() => {
				console.log("Redirecting to home...");
				window.location.href = "/";
			}, 100); // Small delay to ensure localStorage is cleared
		} catch (error) {
			console.error("Error during state reset:", error);
			this.router.navigate(["/home"]);
		}
	}
}
